<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    idPegawaiInternal: {
      type: [String, Number],
      default: null,
    },
    infoPeserta: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      isLoading: false,
      listKompetensi: [],
      sumberData: null,
      pesan: null,
    };
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  watch: {
    modalShow(val) {
      if (val) this.getListKompetensi();
      else this.resetState();
    },
  },

  methods: {
    resetState() {
      this.listKompetensi = [];
      this.sumberData = null;
      this.pesan = null;
    },

    getListKompetensi() {
      if (!this.idPegawaiInternal) return;

      this.isLoading = true;
      this.resetState();

      var config = {
        method: "get",
        // TODO: sesuaikan url dengan endpoint list kompetensi pegawai yang disediakan BE
        url: this.BACKEND_URL_VERSION + "work-order/detail/list-kompetensi-peserta",
        params: { idpegawai_internal: this.idPegawaiInternal },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data_fix = response.data?.data ?? {};
          this.listKompetensi = response_data_fix.data ?? [];
          this.sumberData = response_data_fix.sumber_data ?? null;
          this.pesan = response_data_fix.pesan ?? null;
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text:
              err.response?.data?.data ||
              err.response?.data?.meta?.message ||
              "Gagal memuat daftar kompetensi.",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Detail Kompetensi"
    size="lg"
    hide-footer
  >
    <table class="table table-sm table-borderless mb-3">
      <tbody>
        <tr>
          <td class="text-muted" style="width: 180px">Kode Pegawai Internal</td>
          <td class="text-muted" style="width: 10px">:</td>
          <td class="fw-bold">{{ infoPeserta.kodePegawaiInternal || "-" }}</td>
        </tr>
        <tr>
          <td class="text-muted">Nama Pegawai</td>
          <td class="text-muted">:</td>
          <td class="fw-bold">{{ infoPeserta.namaPegawai || "-" }}</td>
        </tr>
        <tr>
          <td class="text-muted">Nama Profesi</td>
          <td class="text-muted">:</td>
          <td class="fw-bold">{{ infoPeserta.namaProfesi || "-" }}</td>
        </tr>
        <tr>
          <td class="text-muted">Jenjang Jabatan</td>
          <td class="text-muted">:</td>
          <td class="fw-bold">{{ infoPeserta.jenjangJabatan || "-" }}</td>
        </tr>
        <tr>
          <td class="text-muted">Target PEG</td>
          <td class="text-muted">:</td>
          <td class="fw-bold">{{ infoPeserta.targetPeg || "-" }}</td>
        </tr>
        <tr>
          <td class="text-muted">Target Kompetensi</td>
          <td class="text-muted">:</td>
          <td class="fw-bold">{{ infoPeserta.targetKompetensi || "-" }}</td>
        </tr>
        <tr>
          <td class="text-muted">Level Kompetensi</td>
          <td class="text-muted">:</td>
          <td class="fw-bold">{{ infoPeserta.levelKompetensi || "-" }}</td>
        </tr>
      </tbody>
    </table>

    <div class="mb-3" v-if="!isLoading && (sumberData || kuotaPilih !== null)">
      <span class="badge bg-info me-2 text-capitalize" v-if="sumberData">
        Sumber Data: {{ sumberData }}
      </span>
    </div>

    <div v-if="pesan != null" class="alert alert-warning fw-bold mb-3">
      <i class="fa fa-exclamation-triangle text-warning me-1"></i>
      {{ pesan }}
    </div>

    <div v-if="isLoading" class="text-center py-4">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
      <div class="mt-3">Memuat daftar kompetensi...</div>
    </div>

    <div v-else-if="listKompetensi.length > 0" class="table-responsive">
      <table class="table table-sm table-bordered table-hover table-striped align-middle mb-0">
        <thead class="bg-danger text-dark fw-bold text-center">
          <tr>
            <th>Kode</th>
            <th>Nama Kompetensi</th>
            <th>Profesi</th>
            <th>Level</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in listKompetensi" :key="item.idkompetensi || index">
            <td>{{ item.kode_kompetensi || "-" }}</td>
            <td class="fw-bold">{{ item.nama_kompetensi || "-" }}</td>
            <td>{{ item.profesi?.nama_profesi || "-" }}</td>
            <td>{{ item.level_kompetensi?.nama_level || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="alert alert-info fw-bold mb-0">
      <i class="fa fa-info-circle text-primary me-1"></i>
      Tidak ada kompetensi
    </div>

    <div class="text-end mt-3">
      <b-button variant="secondary" @click="$emit('close')">
        Tutup
      </b-button>
    </div>
  </b-modal>
</template>
